import { ReactElement, Suspense, lazy } from 'react';
import { Navigate as Redirect, Route, Routes } from 'react-router-dom';
import { CashFlowPath } from './routes';

const CashClose = lazy(() => import('./pages/CashClose/CashClose'));
const CashCloseHistory = lazy(() => import('./pages/CashCloseHistory/CashCloseHistory'));

export const CashFlowRoutes: React.FC = (): ReactElement => {
  return (
    <Suspense>
      <Routes>
        <Route path={CashFlowPath.CashClose} element={<CashClose />} />
        <Route path={CashFlowPath.CashCloseHistory} element={<CashCloseHistory />} />
        <Route path="*" element={<Redirect to={CashFlowPath.CashClose} replace />} />
      </Routes>
    </Suspense>
  );
};

export const CashFlowRouter: React.FC = () => <CashFlowRoutes />;
